export var PilotApplicationStatus;
(function (PilotApplicationStatus) {
    PilotApplicationStatus["PENDING"] = "pending";
    PilotApplicationStatus["APPROVED"] = "approved";
    PilotApplicationStatus["REJECTED"] = "rejected";
})(PilotApplicationStatus || (PilotApplicationStatus = {}));
//# sourceMappingURL=pilot-application-status.enum.js.map